import { KeyOfTypes } from '@fr/vue/types/helpers';
import { ISimilarHotel } from '../types/similarHotels';

type DistanceType = {
    key: KeyOfTypes<ISimilarHotel, number | null>,
    name: string,
    isAirport?: boolean,
}

export default (hotel: ISimilarHotel): string => {
    const distanceTypes: DistanceType[] = [
        { key: 'distanceBeach', name: 'до пляжа' },
        { key: 'distanceLift', name: 'до подъемника' },
        { key: 'distanceCenter', name: 'до центра' },
        { key: 'distanceAirport', name: 'до аэропорта', isAirport: true },
    ];

    const distanceType = distanceTypes.find(({ key }) => !!hotel[key]);

    if (distanceType) {
        let distance = hotel[distanceType.key];
        const distanceName = distanceType.name;
        const isAirportDistance = !!distanceType.isAirport;

        let units;
        if (distance && distance < 1000 && !isAirportDistance) {
            units = ' м';
        } else {
            units = ' км';
            if (!isAirportDistance && distance) {
                distance = Math.round(distance / 1000);
            }
        }

        return `${distance}${units} ${distanceName}`;
    }

    return '';
};
